import _objectSpread from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/antonremizov/iCloud-Drive-Archive/Cloud-Projects/readit-ios-2/App/Web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { appendEditor } from '@pqina/pintura';
import { sub, unsub } from './events';

var PinturaEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(PinturaEditor, _React$Component);

  var _super = _createSuper(PinturaEditor);

  function PinturaEditor(props) {
    var _this;

    _classCallCheck(this, PinturaEditor);

    _this = _super.call(this, props);
    _this.elementRef = React.createRef();
    _this.editor = undefined;
    return _this;
  }

  _createClass(PinturaEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.elementRef.current) return;

      var props = _objectSpread({}, this.props);

      this.editor = appendEditor(this.elementRef.current, props);
      sub(this, props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var props = _objectSpread({}, this.props);

      Object.assign(this.editor, props);
      sub(this, props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.editor) return;
      unsub(this);
      this.editor.destroy();
      this.editor = undefined;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('div', {
        className: "PinturaRootWrapper ".concat(this.props.className ? this.props.className : '').trim(),
        ref: this.elementRef
      });
    }
  }]);

  return PinturaEditor;
}(React.Component);

export default PinturaEditor;